import { OptionCrmDto } from "./OptionCrmDto";

export class OptionCreateDto {


	//@JsonProperty("resi_lotid@odata.bind")
	"resi_lotid@odata.bind"!: string;
  
    //@JsonProperty("resi_datedebutoption")
	resi_datedebutoption!:Date;

	"resi_optionepourcontactid@odata.bind"!:string | null;
	//@JsonProperty("resi_datefinoption")
	resi_datefinoption!:Date;
	
	//@JsonProperty("resi_dateliberationreelle")
	resi_dateliberationreelle!:Date;
	
	//@JsonProperty("resi_statutlotcode")
	resi_statutlotcode :number = 852810004;
	
	//@JsonProperty("resi_source")
	resi_source:string = "Extranet"; 

    //@JsonProperty('resi_optionnepourcontacttelephone')
	resi_optionnepourcontacttelephone!:string;

	//@JsonProperty("resi_optionnepourcontactcivilite")
	resi_optionnepourcontactcivilite!:number;

	//@JsonProperty("resi_optionnepourcontactprenom")
	resi_optionnepourcontactprenom!:string;

	
	//@JsonProperty("resi_optionnepourcontactemail")
	resi_optionnepourcontactemail!:string;
	
	//@JsonProperty("resi_optionnepourcontactnom")
	resi_optionnepourcontactnom!:string;
	
	//@JsonProperty("resi_reconduction")
	resi_reconduction!:number;
	
	//@JsonProperty("resi_commentaires")
	resi_commentaires!:string;
	
	//@JsonProperty("resi_prenomvendeur")
	resi_prenomvendeur!:string;
	

	//@JsonProperty("resi_emailvendeur")
	resi_nomvendeur!:string;
	
	
	//@JsonProperty("resi_emailvendeur")
	resi_emailvendeur!:string;

	
    
}